import { toJson, fromJson, IWindowService } from 'angular';

export class StorageService {
  private isLocalStorageAvailable = true;
  private isSessionStorageAvailable = true;
  private memoryStorage: { [key: string]: any } = {};

  constructor( private prefix: string,
               private $window: IWindowService ) {
    this.checkLocalStorage();
    this.checkSessionStorage();
  }

  public put( key: string, value: any, session?: boolean ) {
    if ( session ) {
      return this.putToSession(key, value);
    }
    if ( this.isLocalStorageAvailable ) {
      return this.$window.localStorage.setItem(this.prefix + key, toJson(value));
    }
    this.memoryStorage[ this.prefix + key ] = value;
  }

  public get( key: string, session?: boolean ): any {
    if ( session ) {
      return this.getFromSession(key);
    }
    if ( this.isLocalStorageAvailable ) {
      return fromJson(this.$window.localStorage.getItem(this.prefix + key));
    }
    return this.memoryStorage[ this.prefix + key ] || null;
  }

  public remove( key: string, session?: boolean ) {
    if ( session ) {
      return this.removeFromSession(key);
    }
    if ( this.isLocalStorageAvailable ) {
      return this.$window.localStorage.removeItem(this.prefix + key);
    }
    this.memoryStorage[ this.prefix + key ] = null;
  }

  public clear() {
    if ( this.isLocalStorageAvailable ) {
      this.$window.localStorage.clear();
    }
    if ( this.isSessionStorageAvailable ) {
      this.$window.sessionStorage.clear();
    }
    this.memoryStorage = {};
  }

  private putToSession( key: string, value: any ) {
    if ( this.isSessionStorageAvailable ) {
      return this.$window.sessionStorage.setItem(this.prefix + key, toJson(value));
    }
    this.memoryStorage[ this.prefix + key ] = value;
  }

  private getFromSession( key: string ): any {
    if ( this.isSessionStorageAvailable ) {
      return fromJson(this.$window.sessionStorage.getItem(this.prefix + key));
    }
    return this.memoryStorage[ this.prefix + key ];
  }

  private removeFromSession( key: string ) {
    if ( this.isSessionStorageAvailable ) {
      return this.$window.sessionStorage.removeItem(this.prefix + key);
    }
    this.memoryStorage[ this.prefix + key ] = null;
  }

  private checkLocalStorage() {
    try {
      this.$window.localStorage.setItem('checkLocalStorage', 'test');
      this.$window.localStorage.removeItem('checkLocalStorage');
    } catch ( err ) {
      this.isLocalStorageAvailable = false;
      console.log(err.message);
    }
  }

  private checkSessionStorage() {
    try {
      this.$window.sessionStorage.setItem('checkSessionStorage', 'test');
      this.$window.sessionStorage.removeItem('checkSessionStorage');
    } catch ( err ) {
      this.isSessionStorageAvailable = false;
      console.log(err.message);
    }
  }
}



// WEBPACK FOOTER //
// ./app/core/providers/storage/storage.service.ts